import { Link } from "react-router-dom";
import { X, Minus, Plus, ShoppingBag } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useShop } from "../store/ShopContext";
import { formatPrice } from "../lib/api";

export const MiniCart = () => {
  const { miniCartOpen, setMiniCartOpen, cart, cartTotal, updateQty, removeFromCart } = useShop();

  return (
    <AnimatePresence>
      {miniCartOpen && (
        <>
          <motion.div className="fixed inset-0 bg-black/40 z-50" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setMiniCartOpen(false)} />
          <motion.aside
            data-testid="mini-cart-drawer"
            className="fixed inset-y-0 right-0 w-full sm:w-[440px] bg-white z-50 flex flex-col shadow-2xl border-l border-black/10"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            <div className="h-[72px] px-6 flex items-center justify-between border-b border-black/10">
              <p className="font-serif text-2xl">Coșul tău</p>
              <button data-testid="mini-cart-close" aria-label="Închide" className="icon-btn" onClick={() => setMiniCartOpen(false)}>
                <X size={20} strokeWidth={1.5} />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-6">
              {cart.length === 0 ? (
                <div data-testid="mini-cart-empty" className="h-full flex flex-col items-center justify-center text-center">
                  <ShoppingBag size={32} strokeWidth={1} className="text-[#B4A38E] mb-4" />
                  <p className="font-serif text-2xl">Coșul este gol</p>
                  <p className="text-sm text-[#737373] mt-2 max-w-[240px]">Descoperă colecția THULE și adaugă primul produs.</p>
                  <Link to="/catalog" onClick={() => setMiniCartOpen(false)} className="btn-outline mt-8">Explorează catalogul</Link>
                </div>
              ) : (
                <ul className="divide-y divide-black/5">
                  {cart.map((item) => (
                    <li key={item.key} data-testid={`mini-cart-item-${item.slug}${item.variant ? `-${item.variant.replace(/\s/g, "-").toLowerCase()}` : ""}`} className="py-5 flex gap-4">
                      <Link to={`/produs/${item.slug}`} onClick={() => setMiniCartOpen(false)} className="surface w-24 h-28 flex items-center justify-center p-2 shrink-0">
                        <img src={item.image} alt={item.name} className="product-img max-h-full object-contain" />
                      </Link>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between gap-3">
                          <div>
                            <p className="font-medium text-sm leading-snug">{item.name}</p>
                            <p className="text-xs text-[#737373] mt-0.5">{item.variant || item.color}</p>
                          </div>
                          <button data-testid={`mini-cart-remove-${item.slug}`} aria-label="Elimină" onClick={() => removeFromCart(item.key)} className="text-[#737373] hover:text-[#0A0A0A]">
                            <X size={16} strokeWidth={1.5} />
                          </button>
                        </div>
                        <div className="flex items-center justify-between mt-3">
                          <div className="inline-flex items-center border border-black/15">
                            <button data-testid={`mini-cart-dec-${item.slug}`} aria-label="Scade" className="h-8 w-8 flex items-center justify-center hover:bg-[#F2F2EF]" onClick={() => updateQty(item.key, item.qty - 1)}><Minus size={12} /></button>
                            <span data-testid={`mini-cart-qty-${item.slug}`} className="w-8 text-center text-sm">{item.qty}</span>
                            <button data-testid={`mini-cart-inc-${item.slug}`} aria-label="Crește" className="h-8 w-8 flex items-center justify-center hover:bg-[#F2F2EF]" onClick={() => updateQty(item.key, item.qty + 1)}><Plus size={12} /></button>
                          </div>
                          <p className="font-semibold text-sm">{formatPrice(item.price * item.qty)}</p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {cart.length > 0 && (
              <div className="border-t border-black/10 px-6 py-6 space-y-4">
                <div className="flex justify-between text-sm">
                  <span className="text-[#737373]">Subtotal</span>
                  <span data-testid="mini-cart-subtotal" className="font-semibold">{formatPrice(cartTotal)}</span>
                </div>
                <p className="text-xs text-[#737373]">Transportul și taxele se calculează la finalizarea comenzii.</p>
                <Link to="/checkout" data-testid="mini-cart-checkout-btn" onClick={() => setMiniCartOpen(false)} className="btn-primary w-full">Finalizează comanda</Link>
                <Link to="/cos" data-testid="mini-cart-view-cart" onClick={() => setMiniCartOpen(false)} className="btn-outline w-full">Vezi coșul</Link>
              </div>
            )}
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};
